var map = {
	"./gall1.webp": 281,
	"./gall10.webp": 381,
	"./gall2.webp": 275,
	"./gall3.webp": 562,
	"./gall4.webp": 187,
	"./gall5.webp": 331,
	"./gall6.webp": 895,
	"./gall7.webp": 56,
	"./gall8.webp": 101,
	"./gall9.webp": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;